import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-footer-email',
  templateUrl: './icon-footer-email.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFooterEmailComponent {}
